import {GetWomenChannelUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetWomenChannelUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetWomenChannelUrl = (): GetWomenChannelUrl =>
	new RemoteGetWomenChannelUrl(
		makeBFFApiUrl(ExternalLinkPoint.womenChannel),
		makeAuthorizeHttpClientDecorator(),
	);

export const makeMockedGetWomenChannelUrl = (): GetWomenChannelUrl => ({
	get: async () => ({
		url: '/mocks/test-page-2.html',
	}),
});
